import { Company, Status } from ".";

export class BusinessUnit{
    id?: number;
    code?: string;
    name?: string;
    status?: Status;
    company?: Company;
    createdAt?: Date = new Date();
    createdUserId?: number;
    updateAt?: Date;
    updateUserId?: number;
}
